import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React, { useCallback, useState } from 'react';

import { EstateActualPriceHistoryChart } from './EstateActualPriceHistoryChart';
import { EstateActualPriceHistoryTable } from './EstateActualPriceHistoryTable';

export function EstateActualPriceHistoryDialog(props: {
  open: boolean;
  onClose: (actualPrice?: number) => void;
  estateId: number;
}) {
  const { open, onClose, estateId } = props;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [prices, setPrices] = useState<
    {
      date: string;
      actualPrice: number;
    }[]
  >([]);

  const handlePricesChange = useCallback(
    (newPrices: { date: string; actualPrice: number }[]) => {
      setPrices(newPrices);
    },
    [],
  );

  const handleClose = () => {
    const actualPrice = [...prices].sort(
      (a, b) => new Date(b.date).valueOf() - new Date(a.date).valueOf(),
    )[0];
    onClose(actualPrice?.actualPrice);
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      onClose={() => {
        handleClose();
      }}
      fullScreen={isSmallScreen}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        График актуальной стоимости
        <IconButton onClick={() => handleClose()} sx={{ ml: 'auto', mr: -1 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container sx={{ m: 0 }}>
          <Grid
            xs={12}
            md={6}
            sx={{
              alignItems: 'center',
            }}
          >
            <EstateActualPriceHistoryChart prices={prices} />
          </Grid>
          <Grid xs={12} md={6} sx={{ pl: 1 }}>
            <EstateActualPriceHistoryTable
              estateId={estateId}
              onPricesChange={handlePricesChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={() => handleClose()}>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
}
